import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { useAuthState } from "../../Helper/Context";

export const CommonDashboardBtn = (props) => {
    const { DashType, setDashType, Name } = props

    const navigate = useNavigate()
    const userDetails = useAuthState();
    const { M_ProjectTypeID, RoleID } = userDetails.user
    const [ActiveBtn, SetActiveBtn] = useState(Name)

    const btnData = [
        {
            name: "Garden",
            id: 6,
            title: "Garden",
            bgColor: "background"
        },
        {
            name: "Water Supply",
            id: 1,
            title: "Water Supply",
            bgColor: "background"
        },
        {
            name: "Sewerage",
            id: 2,
            title: "Sewerage",
            bgColor: "background"
        },
        {
            name: "STP",
            id: 3,
            title: "STP",
            bgColor: "background"
        },
        {
            name: "Road Work",
            id: 4,
            title: "Road Work",
            bgColor: "background"
        },
        // {
        //     name: "Electrical",
        //     id: 5,
        //     title: "Electrical",
        //     backkground3: "background3"

        // },

    ]


    const GardenMaintainanceNavigate = (name, screenFlag) => {
        // console.log('name', name)
        if (name === "Water Supply") {
            if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
                navigate(`/watersupply?name=${name}&ProjectTypeId=1&DashboardName=Water Supply`)
                sessionStorage.removeItem('FJ853K')
            }
        } else if (name === "Sewerage") {
            if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
                navigate(`/sewerage?name=${name}&ProjectTypeId=2&DashboardName=Sewerage`)
            }
        } else if (name === "STP") {
            if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
                navigate(`/stpdashboard?name=${name}&ProjectTypeId=3&DashboardName=STP`)
            }
        } else if (name === "Road Work") {
            if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
                navigate(`/dashboard?name=${name}&ProjectTypeId=4&DashboardName=Road`)
            }
        } else if (name === "Electrical") {
            if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
                // navigate(`/watersupply?name=${name}&ProjectTypeId=1&DashboardName=Electrical`)
            }
        } else if (name === "Garden") {
            if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
                navigate(`/garden?name=${name}&ProjectTypeId=5&DashboardName=Garden`)
            }
        }
    }

    const preloadImage = (src) => {
        const img = new Image();
        img.src = src;
        // console.log('img',img)
    };

    useEffect(() => {
        preloadImage('./assets/img/water-system-w.png', true)
        preloadImage('./assets/img/water-system-removebg-preview.png', true)
        preloadImage("./assets/img/sewerage-w.png", true);
        preloadImage("./assets/img/sewerage-removebg-preview.png", true);
        preloadImage('./assets/img/water-w.png', true)
        preloadImage('./assets/img/water-removebg-preview.png', true)
        preloadImage('./assets/img/work-tools-w.png', true)
        preloadImage('./assets/img/work-tools-removebg-preview.png', true)
        preloadImage('./assets/img/sustainable-energy-w.png', true)
        preloadImage('./assets/img/work-tools-removebg-preview.png', true)
        preloadImage('./assets/img/park-w.png', true)
        preloadImage('./assets/img/park-removebg-preview.png', true)
    }, []);

    // useEffect(() => {
    //     console.log("ActiveBtn", ActiveBtn)
    // }, [ActiveBtn])


    return (
        <>

            <div className="row">
                <div className="col-12 text-start">
                    {
                        btnData && btnData.map(i => {
                            const isDisabled = (RoleID == 3 && M_ProjectTypeID == 5);
                            const isActive = (ActiveBtn == i.name);
                            return (
                                <button type="button"
                                    // onClick={() => GardenMaintainanceNavigate(i?.title)}
                                    onClick={(e) => {
                                        if (isDisabled) {
                                            e.preventDefault();
                                            return;
                                        }
                                        SetActiveBtn(i.name);
                                        GardenMaintainanceNavigate(i.name);
                                    }}
                                    style={{ cursor: (isDisabled) ? "not-allowed" : "pointer" }}

                                    className={`btn  mx-1 fs-6  ${isActive ? (i?.bgColor) : "btn-secondarys"}`}>{i?.name}</button>
                            )
                        })

                    }

                    {/* <button type="button" class="btn btn-secondarys mx-2 fs-6">शिक्षण विभाग</button> */}
                </div>
            </div>
        </>
    )
}